import baseRequest from "../_core/baseRequest";

export default {
    createAndActivateCourierWallet: params =>
        baseRequest.post(
            `/wallet/courier/${params?.courierId}/create-and-activate-courier-wallet`,
            params
        ),

    getCourierWalletWithDailyTransactionsSummary: params =>
        baseRequest.get(
            `/wallet/courier/${params?.courierId}?${
                params?.startDate ? `startDate=${params.startDate}` : ""
            }&${params?.endDate ? `endDate=${params.endDate}` : ""}`
        ),

    getDailyTransactionsSummary: params =>
        baseRequest.get(
            `/wallet/courier/${params?.courierId}/daily-summary?${
                params?.dailyTransactionId ? `dailyTransactionId=${params.dailyTransactionId}` : ""
            }`,
            params
        ),

    getDailyTransactions: params =>
        baseRequest.get(
            `/wallet/courier/${params?.courierId}/daily-transactions?${
                params?.dailyTransactionId ? `dailyTransactionId=${params.dailyTransactionId}` : ""
            }`,
            params
        ),

    getCourierCreditLogSummary: params =>
        baseRequest.post(`/wallet/courier/${params?.courierId}/credit-log-summary`, params),

    getCourierPaymentInvoices: params =>
        baseRequest.get(
            `/wallet/courier/${params?.courierId}/payment-invoices?${
                params?.startDate ? `startDate=${params.startDate}` : ""
            }&${params?.endDate ? `endDate=${params.endDate}` : ""}${
                params?.status ? `&status=${params.status}` : ""
            }`
        ),

    getCourierWalletPayments: params =>
        baseRequest.get(
            `/wallet/courier/${params?.courierId}/payments?${
                params?.startDate ? `&startDate=${params.startDate}` : ""
            }${params?.endDate ? `&endDate=${params.endDate}` : ""}${
                params?.status ? `&status=${params.status}` : ""
            }`
        ),

    listWalletCouriers: params => baseRequest.post(`/wallet/courier`, params),

    blockWithdrawAction: params => baseRequest.post(`/wallet/block-withdraw-action`, params),

    unblockWithdrawAction: params => baseRequest.post(`/wallet/unblock-withdraw-action`, params),

    getWalletInvoiceVendors: params => baseRequest.get(`/wallet/invoice-vendors`, params),
    uploadWalletCourierFinancialFile: params =>
        baseRequest.post("/wallet/courier-financial-uploads", params),
    listWalletCourierFinancials: params =>
        baseRequest.get(
            `/wallet/courier-financial-uploads?${
                params?.courierId ? `courierId=${params.courierId}` : ""
            }${params?.type ? `&type=${params.type}` : ""}`
        ),
    listUploadTypes: () => baseRequest.get(`/wallet/upload-transaction-types`),
    getCourierFinancialUploadsTemplate: () => baseRequest.get(`/wallet/courier-financial-uploads-template`),
    createFinancialUploadExcelToSpecificCourier: params => baseRequest.post(`/wallet/create-financial-upload-excel-to-specific-courier`, params),
    generateWithdrawSummary: params => baseRequest.post(`/wallet/generate-withdraw-summary`, params),
    approveWithdraw: params => baseRequest.post(`/wallet/approve-withdraw`, params),
    getCourierFinancialUploadsTemplate: () =>
        baseRequest.get(`/wallet/courier-financial-uploads-template`)
};
